import { render } from "./App.vue?vue&type=template&id=9d160112"
const script = {}

import exportComponent from "/Users/sai/Desktop/WEB/Held by Sound/App/held/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__